import React from 'react';
import { Box, CircularProgress, Fade } from '@mui/material';

interface CalendarLoadingOverlayProps {
  isLoading: boolean;
  isBackgroundLoading: boolean;
}

const CalendarLoadingOverlay: React.FC<CalendarLoadingOverlayProps> = ({
  isLoading,
  isBackgroundLoading,
}) => {
  return (
    <>
      {/* Background loading indicator - shows in top-right corner */}
      {isBackgroundLoading && (
        <Box
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            zIndex: 102,
            p: 1.5,
            borderRadius: 1,
            bgcolor: 'background.paper',
            boxShadow: 2,
            display: 'flex',
            alignItems: 'center',
            border: '1px solid',
            borderColor: 'primary.light',
          }}
        >
          <CircularProgress size={16} sx={{ color: 'primary.main' }} />
        </Box>
      )}

      {/* Full loading overlay with blur effect - shows for initial/full loading */}
      {isLoading && (
        <Fade in={isLoading}>
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              backdropFilter: 'blur(2px)',
              zIndex: 100,
            }}
          >
            <CircularProgress size={60} />
          </Box>
        </Fade>
      )}
    </>
  );
};

export default CalendarLoadingOverlay;